



import Page from '../PostSales/sale/PostSale.vue'
export default {
  name: 'postsaleOEM',
  components: { Page },
}
